<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="672px" :before-close="closeModal">
    <Note class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center">
       Revise os dados do seu cadastro
    </h3>
    <p class="text-center">Atualize as informações indicadas abaixo por nossa equipe:</p>

        <div class="border observation-box my-4 mx-4 py-4 pl-5">
            <caption class="c-nmidone">
                observação
            </caption>
            <h5 class="c-ndarkfour medium d-inline-block mb-0 mr-5">
                {{ review }}
            </h5>
        </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <button :class="`btn btn-${getPrimaryColor}`" @click="nextStep">
            Visualizar cadastro
        </button>
    </span>
</el-dialog>
</template>

<script>
import Note from '@/components/icons/Note'
export default {
    components: {
        Note
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
        review:{
            required: true,
            type: String,
            default: ''
        }
    },
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        nextStep(){
            this.$emit('nextStep', false)
        }
    },
}
</script>

<style lang="scss" scoped>
.observation-box {
    max-height: 150px;
    overflow: scroll;
}
</style>